import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import useQueryString, { QueryStringResult } from 'use-query-string'

export const useQueryStringBase = () => {
  const history = useHistory()
  const location = useLocation()
  return useQueryString(
    location as unknown as Location,
    history.replace,
    { parseNumbers: true, parseBooleans: true },
    { skipNull: true, skipEmptyString: true }
  )
}

export const useUrlState = <T>(
  paramKey: string,
  defaultValue: T | undefined,
  queryString: ReturnType<typeof useQueryString>
) => {
  const [query, setQuery] = queryString as [QueryStringResult[0], QueryStringResult[1]]

  React.useEffect(() => {
    if (defaultValue) {
      setUrlValue(defaultValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const urlValue = React.useMemo(() => query[paramKey] || defaultValue, [query])
  const setUrlValue = (value: T) => {
    setQuery({ [paramKey]: value || undefined })
  }

  return [urlValue as T, setUrlValue] as const
}
